export default __webpack_public_path__ + "static/media/terminal3.bf25440f.svg";